module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0zIDEzSDExVjNIM1YxM1pNMyAyMUgxMVYxNUgzVjIxWk0xMyAyMUgyMVYxMUgxM1YyMVpNMTMgM1Y5SDIxVjNIMTNaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/navbar/dashboard.svg
// module id = 4UF/
// module chunks = 1